module.exports = __webpack_public_path__ + "static/media/Arcanine_gaussian2.f01d5f0d.png";